import React, { useState } from "react";
import "./component.css";
import Sidebar from "../../Navigation/Sidebar/Sidebar";
import SingingContract from "../../../assests/SingingContract.svg";
import { Button, Box, TextField } from "@mui/material";
import leftArrow from "../../../assests/leftArrow.svg";
import { Link, useNavigate, useHistory } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import LoadingSpinner from "../../Loading/component";
import gift from "../../../assests/gift.svg"
import discount from "../../../assests/Discount.svg"
import  wallet from "../../../assests/Wallet.svg"


export const CouponFreegiftComponent = ({
  
    couponCreationStep8,
   
    renderInputFields,
  
}) => {
   
      
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/");
  };
  const goback = () => {
    navigate(-1);
  };
  
  return (
    <div className="main-div">
      <div>
        <Sidebar />
      </div>

      <div>
        <div style={{ marginLeft: "42px", marginTop: "20px" }}>
          <h2>
            <img
              onClick={handleClick}
              style={{ width: "22px", cursor: "pointer" }}
              src={leftArrow}
              alt=""
            />{" "}
            Create Coupon
          </h2>
        </div>
        <div className="bDetrails-div">
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              width: "1328px",
            }}
          >
            <div className="inputDiv">
              <img  style={{marginLeft:"20px", marginBottom:"90px", width:"32px", position:"absolute"}} src={gift} alt="" />
      <Box
        sx={{
          width: 600,
          maxWidth: "100%",
          alignItems: "center"
        }}
      >
        <label htmlFor="" className="couponLabel" style={{width:"1090px", marginTop:"10px", fontSize:"20px", marginLeft:"90px"}}>
        Free Gift
        </label>
        <div>
       
    {renderInputFields()}
      
      
  
        </div>
        
      </Box>
     
     
      <Box className="usersrolebtn">
        <Button className="backbtn" onClick={goback}>
          Cancel
        </Button>



<Button
            variant="contained"
           onClick={(e)=>{couponCreationStep8(e)}}
            sx={{
              borderRadius: 2,
              textTransform: "none",
              width: 120,
              height: 40,
              background:"rgba(0, 177, 119, 1)",
            }}
          >
            NEXT
          </Button>
      </Box>
      
    </div>
          </div>
          
        </div>
        
      </div>
    </div>
  );
};
